(function () {
  'use strict';

  function initBrandBanner(root) {
    if (!root || root.dataset.abbInit === 'true') return;

    var viewport = root.querySelector('.atomized-brand-banner__viewport');
    var track = root.querySelector('.atomized-brand-banner__track');
    if (!viewport || !track) return;

    // Solo activamos pausa + drag si el bloque tiene "Pausar al pasar el mouse" activado.
    var pauseOnHover = viewport.hasAttribute('data-pause-on-hover');
    if (!pauseOnHover) return;

    root.dataset.abbInit = 'true';
    viewport.classList.add('atomized-brand-banner__viewport--interactive');

    var half = 0;
    function measure() {
      half = track.scrollWidth / 2;
    }
    measure();
    window.addEventListener('resize', measure);

    function getTranslateX(el) {
      var style = window.getComputedStyle(el);
      var transform = style.transform;
      if (!transform || transform === 'none') return 0;
      var match = transform.match(/matrix\(([^)]+)\)/);
      if (!match) return 0;
      var parts = match[1].split(',');
      return parseFloat(parts[4]) || 0;
    }

    function getDuration() {
      var raw = window.getComputedStyle(viewport).getPropertyValue('--abb-speed');
      var seconds = parseFloat(raw);
      return isNaN(seconds) || seconds <= 0 ? 40 : seconds;
    }

    function getDirection() {
      var raw = (window.getComputedStyle(viewport).getPropertyValue('--abb-direction') || '').trim();
      return raw === 'reverse' ? 'reverse' : 'normal';
    }

    function wrap(px) {
      if (half <= 0) return px;
      var wrapped = px % half;
      if (wrapped > 0) wrapped -= half;
      return wrapped;
    }

    var isPointerDown = false;
    var isDragging = false;
    var startClientX = 0;
    var startX = 0;
    var activePointerType = 'mouse';
    var suppressNextClick = false;

    function freezeAtCurrentPosition() {
      var current = getTranslateX(track);
      track.style.animation = 'none';
      track.style.transform = 'translateX(' + current + 'px)';
      return current;
    }

    function resumeAnimation() {
      if (half <= 0) measure();
      var current = getTranslateX(track);
      var fraction = half > 0 ? Math.min(Math.abs(current) / half, 1) : 0;
      var duration = getDuration();
      var direction = getDirection();
      var elapsed = direction === 'reverse' ? duration * (1 - fraction) : duration * fraction;

      track.style.transform = '';
      track.style.animation = '';
      track.style.animationDelay = '-' + elapsed + 's';
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      isPointerDown = true;
      isDragging = false;
      activePointerType = e.pointerType || 'mouse';
      startClientX = e.clientX;
      startX = freezeAtCurrentPosition();

      viewport.classList.add('is-grabbing');

      if (activePointerType === 'mouse' && viewport.setPointerCapture && e.pointerId !== undefined) {
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (err) {
          /* noop */
        }
      }
    }

    function onPointerMove(e) {
      if (!isPointerDown) return;
      var deltaX = e.clientX - startClientX;

      if (!isDragging && Math.abs(deltaX) > 4) {
        isDragging = true;
      }

      if (isDragging) {
        if (e.cancelable) e.preventDefault();
        var next = wrap(startX + deltaX);
        track.style.transform = 'translateX(' + next + 'px)';
      }
    }

    function endDrag() {
      if (!isPointerDown) return;
      isPointerDown = false;
      viewport.classList.remove('is-grabbing');

      if (isDragging) {
        suppressNextClick = true;
        window.setTimeout(function () {
          suppressNextClick = false;
        }, 0);
      }
      isDragging = false;
    }

    function onPointerUp() {
      endDrag();
      // En mouse: se queda pausado hasta que el cursor salga del banner (mouseleave).
      // En touch: no existe "salir del banner", así que retomamos el movimiento al soltar.
      if (activePointerType !== 'mouse') {
        resumeAnimation();
      }
    }

    function onPointerCancel() {
      endDrag();
      if (activePointerType !== 'mouse') {
        resumeAnimation();
      }
    }

    function onMouseEnter() {
      if (!isPointerDown) {
        freezeAtCurrentPosition();
      }
    }

    function onMouseLeave() {
      if (isPointerDown) return;
      resumeAnimation();
    }

    function onClickCapture(e) {
      if (suppressNextClick) {
        e.preventDefault();
        e.stopPropagation();
        suppressNextClick = false;
      }
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerCancel);
    viewport.addEventListener('mouseenter', onMouseEnter);
    viewport.addEventListener('mouseleave', onMouseLeave);
    viewport.addEventListener('click', onClickCapture, true);
  }

  function initAll(scope) {
    var context = scope || document;
    var banners = context.querySelectorAll ? context.querySelectorAll('.atomized-brand-banner') : [];
    for (var i = 0; i < banners.length; i++) {
      initBrandBanner(banners[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Soporte para el theme editor (reinicializar al agregar/editar la sección).
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
